























import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { ExamineeStudentProgress } from '@/models/evalSetting/evaluator-student-progress';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvaluatorStudentProgress } from '@/models/evalSetting/examinee-student-progress';
import { GEnum } from '@/constants/enum.defination';
import { GPageBase } from '@/mixins';
import { DeleteEvalRequest } from '@/models/evalSetting/delete-eval-request';

@Component({
  name: 'GExamDetailProgressDeleteEvalRequestConfirmModal',
  computed: {},
  methods: {},
})
export default class GExamDetailProgressDeleteEvalRequestConfirmModal extends Mixins(GPageBase) {
  showModal: boolean = false;
  selectedStudentID: number = 0;

  @Prop({ default: false }) value: boolean;
  @Prop({
    default: (): ExamineeStudentProgress => {
      return new ExamineeStudentProgress();
    },
  })
  examinee: ExamineeStudentProgress;
  @Prop({
    default: (): EvaluatorStudentProgress => {
      return new EvaluatorStudentProgress();
    },
  })
  evaluator: EvaluatorStudentProgress;

  @Prop({ default: false }) isFilteredByEvaluator: boolean;

  @Watch('value')
  openModal(value: boolean) {
    this.showModal = value;
  }

  mounted() {
    // this.studentColumns = [this.columnAction, this.columnStudentNumber, this.columnFullName, this.columnGrade, this.columnSchoolClassName, this.columnTags];
  }

  handleUpdate() {
    const deleteEvalRequest: DeleteEvalRequest = {
      evalSettingID: evalSettingModule.evalSettingDetail.evalSettingID,
      examineeStudentID: this.examinee.examineeStudentID,
      evaluatorStudentID: this.evaluator.evaluatorStudentID,
    } as DeleteEvalRequest;
    evalSettingModule.deleteEvalRequest(deleteEvalRequest).then((err: any) => {
      if (err.code) {
        this.$emit('input', false);
        return;
      }
      const evaluatorIndex: number = this.examinee.evaluatorStudents.findIndex((s: EvaluatorStudentProgress) => s.evaluatorStudentID === this.evaluator.evaluatorStudentID);
      if (evaluatorIndex > -1) {
        this.examinee.evaluatorStudents.splice(evaluatorIndex, 1);
      }
      this.showNotice(GEnum.MessageType.Success, this.$t('DELETE_EVALUATOR').toString(), this.$t('MESSAGE_DELETE_EVALUATOR', {value1: this.examinee.fullName, value2: this.evaluator.fullName}).toString(), 10);
      this.$emit('input', false);
      this.$emit('updateTable');
    });
  }

  handleCancel() {
    this.$emit('input', false);
  }
}
